import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WorkflowIdPage.PromotionButtons', {
    tryIt: 'Try it for free',
    learnMore: 'Learn more',
});
